import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useBusinessDay } from '../../../../shared/hooks/useBusinessDay.js';

interface AuditRow {
  readonly auditId: string;
  readonly auditEvent: string;
  readonly entityType: string;
  readonly performedBy: string;
  readonly createdAt: string;
}

export function M19AuditDashboardPage(): ReactNode {
  const { t } = useTranslation();
  // Dates follow the tenant's DISPLAY_DATE_FORMAT, not the reader's language picker.
  const { at } = useBusinessDay();
  const { token } = useAuth();
  const [rows, setRows] = useState<AuditRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: AuditRow[] }>('/v1/platform/audit', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.audit.loading')}</p>;
  return (
    <main aria-label="audit-dashboard">
      <h1>{t('m19.audit.title')}</h1>
      <table aria-label="audit-table">
        <thead><tr><th>{t('m19.audit.colEvent')}</th><th>{t('m19.audit.colEntity')}</th><th>{t('m19.audit.colPerformedBy')}</th><th>{t('m19.audit.colWhen')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.auditId}>
              <td>{a.auditEvent}</td>
              <td>{a.entityType}</td>
              <td>{a.performedBy}</td>
              <td>{at(a.createdAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
